cb.define(['common/common_VM.Extend.js'], function (common) {
  var ST_st_stockinandoutdetail_filterVM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
      viewmodel.on("afterInit", function () {
        //单据日期默认值
        var currentDate = new Date().format('yyyy-MM-dd');
        viewmodel.get('vouchdate').getFromModel().setValue(currentDate);
        viewmodel.get('vouchdate').getToModel().setValue(currentDate);

        //单据类型 只显示零售单、其他出其他入、店存出店存入五种单据
        viewmodel.get("receipttype").getFromModel().on('beforeBrowse', function (data) {
          var receipttypeCodes = [];
          receipttypeCodes.push('A01');
          receipttypeCodes.push('A07');
          receipttypeCodes.push('A08');
          receipttypeCodes.push('A09');
          receipttypeCodes.push('A10');

          var conditionReceipttype = {
            "isExtend": true,
            simpleVOs: []
          };
          conditionReceipttype.simpleVOs.push({
            field: 'code',
            op: 'in',
            value1: receipttypeCodes
          });

          viewmodel.get('receipttype').getFromModel().setTreeFilter(conditionReceipttype);
        });

        //单据类型变化以后清空业务类型
        viewmodel.get("receipttype").getFromModel().on('afterValueChange', function (data) {
          viewmodel.get('bustype_name').getFromModel().setValue(null);
        });

        //业务类型 只显示零售单、其他出其他入、店存出店存入五种单据下的业务类型，如果前面已经选择了单据，那么受前面已选单据类型的限制
        viewmodel.get("bustype_name").getFromModel().on('beforeBrowse', function (data) {
          var receipttypeCodes = [];
          receipttypeCodes.push('A01');
          receipttypeCodes.push('A07');
          receipttypeCodes.push('A08');
          receipttypeCodes.push('A09');
          receipttypeCodes.push('A10');
          var conditionBustype = {
            "isExtend": true,
            simpleVOs: []
          };
          conditionBustype.simpleVOs.push({
            field: 'receipttype.code',
            op: 'in',
            value1: receipttypeCodes
          });

          if (viewmodel.get("receipttype").getData().value1 != null && viewmodel.get("receipttype").getData().value1 != "" && viewmodel.get("receipttype").getData().value1.length != 0) {
            var receipttypeIds = viewmodel.get("receipttype").getData().value1;
            conditionBustype.simpleVOs.push({
              field: 'receipttype.id',
              op: 'in',
              value1: receipttypeIds
            });
          }

          viewmodel.get('bustype_name').getFromModel().setFilter(conditionBustype);
        });

        //组织附默认值
        var orgId = cb.rest.AppContext.user.orgId;
        var userOrgs = cb.rest.AppContext.user.userOrgs;
        var defaultValue = {id:orgId};
        var currentOrg = userOrgs && userOrgs.find(function(item){
          return item.org === orgId;
        });
        if (currentOrg) {
          defaultValue.code = currentOrg.org_code;
          defaultValue.name = currentOrg.org_name;
        }
        viewmodel.get('org').getFromModel().setValue([defaultValue]);
        
        //只能参照到当前用户有权限的组织
        viewmodel.get("org").getFromModel().on('beforeBrowse', function (data) {
          var userOrgs = cb.rest.AppContext.user.userOrgs;
          var org_ids = [];
          if (userOrgs != null && userOrgs != "" && userOrgs.length != 0) {
            for (var i = 0; i < userOrgs.length; i++) {
              org_ids.push(userOrgs[i].org);
            }
            var conditionOrg = {
              "isExtend": true,
              simpleVOs: []
            };
            conditionOrg.simpleVOs.push({
              field: 'id',
              op: 'in',
              value1: org_ids
            });
            viewmodel.get('org').getFromModel().setFilter(conditionOrg);
          } else {
            cb.utils.alert("无组织权限！", 'error');
            return false;
          }
        });

        //组织变化以后清空门店
        viewmodel.get("org").getFromModel().on('afterValueChange', function (data) {
          viewmodel.get('store_name').getFromModel().setValue(null);
        });
        //地区变化以后清空门店
        viewmodel.get("areaClass").getFromModel().on('afterValueChange', function (data) {
          viewmodel.get('store_name').getFromModel().setValue(null);
        });
        //门店类型变化以后清空门店
        viewmodel.get("storeType").getFromModel().on('afterValueChange', function (data) {
          viewmodel.get('store_name').getFromModel().setValue(null);
        });

        //门店过滤
        viewmodel.get("store_name").getFromModel().on('beforeBrowse', function (data) {
          //只能参照到当前用户有权限的门店
          var userStores = cb.rest.AppContext.user.userStores;
          var store_ids = [];
          if (userStores != null && userStores != "" && userStores.length != 0) {
            for (var i = 0; i < userStores.length; i++) {
              store_ids.push(userStores[i].store);
            }
            var conditionStore = {
              "isExtend": true,
              simpleVOs: []
            };

            conditionStore.simpleVOs.push({
              field: 'id',
              op: 'in',
              value1: store_ids
            });

            //如果前面选了组织，那么门店必须属于前面选择的组织
            if (viewmodel.get("org").getData().value1 != null && viewmodel.get("org").getData().value1 != "" && viewmodel.get("org").getData().value1.length != 0) {
              var orgIds = viewmodel.get("org").getData().value1;
              conditionStore.simpleVOs.push({
                field: 'org',
                op: 'in',
                value1: orgIds
              });
            }
            //如果前面选了地区，那么门店必须属于前面选择的地区
            if (viewmodel.get("areaClass").getData().value1 != null && viewmodel.get("areaClass").getData().value1 != "" && viewmodel.get("areaClass").getData().value1.length != 0) {
              var areaClassIds = viewmodel.get("areaClass").getData().value1;
              conditionStore.simpleVOs.push({
                field: 'areaClass',
                op: 'in',
                value1: areaClassIds
              });
            }
            //如果前面选了门店类型，那么门店必须属于前面选择的门店类型
            if (viewmodel.get("storeType").getData().value1 != null && viewmodel.get("storeType").getData().value1 != "" && viewmodel.get("storeType").getData().value1.length != 0) {
              var storeType = viewmodel.get("storeType").getData().value1;
              conditionStore.simpleVOs.push({
                field: 'storeType',
                op: 'eq',
                value1: storeType
              });
            }

            viewmodel.get('store_name').getFromModel().setFilter(conditionStore);
          } else {
            cb.utils.alert("无门店权限！", 'error');
            return false;
          }
        });



        // //仓库过滤条件只显示门店仓*/
        // var conditionWarehouse = {
        // 	"isExtend": true,
        // 	simpleVOs: []
        // };
        // //var storeid = cb.rest.AppContext.user.storeId;
        // conditionWarehouse.simpleVOs.push({
        // 	field: 'wStore',
        // 	op: 'eq',
        // 	value1: true
        // });
        // viewmodel.get('warehouse_name').getFromModel().setFilter(conditionWarehouse);

        //门店变化以后清空仓库
        viewmodel.get("store_name").getFromModel().on('afterValueChange', function (data) {
          viewmodel.get('warehouse_name').getFromModel().setValue(null);
        });

        //选择仓库之前，如果选择门店，按照门店过滤,否则根据当前用户有权限的门店进行过滤
        viewmodel.get("warehouse_name").getFromModel().on('beforeBrowse', function (data) {
          var promise = new cb.promise();
          var store_ids = [];
          if (viewmodel.get("store_name").getData().value1 != null && viewmodel.get("store_name").getData().value1 != "" && viewmodel.get("store_name").getData().value1.length != 0) {
            store_ids = viewmodel.get("store_name").getData().value1;
          } else {
            var userStores = cb.rest.AppContext.user.userStores;
            if (userStores != null && userStores != "" && userStores.length != 0) {
              for (var i = 0; i < userStores.length; i++) {
                store_ids.push(userStores[i].store);
              }
            }
          }
          if (store_ids != null && store_ids != "" && store_ids.length != 0) {
            var proxy = cb.rest.DynamicProxy.create({
              settle: {
                url: "/bill/ref/getWarehousesFromStores",
                method: "POST"
              }
            });
            var params = {
              storeIds: store_ids,
            };
            proxy.settle(params, (err, result) => {
              if (err) {
                cb.utils.alert(err.message, 'error');
              }

              if (result === undefined || result.length == 0) {
                cb.utils.alert("没有查询到当前选择店铺的仓库！", 'error');
              } else {
                var conditionWarehouse = {
                  "isExtend": true,
                  simpleVOs: []
                };
                //门店下的仓库
                conditionWarehouse.simpleVOs.push({
                  field: 'id',
                  op: 'in',
                  value1: result
                });
                //门店仓
                conditionWarehouse.simpleVOs.push({
                  field: 'wStore',
                  op: 'eq',
                  value1: true
                });
                //如果前面选了组织，那么还得加上组织的过滤
                var orgIds = viewmodel.get("org").getData().value1;
                conditionWarehouse.simpleVOs.push({
                  field: 'org',
                  op: 'in',
                  value1: orgIds
                });
                viewmodel.get('warehouse_name').getFromModel().setFilter(conditionWarehouse);
                promise.resolve();
              }
            });
          } else {
            cb.utils.alert("无门店权限！", 'error');
          }
          return promise;
        });


         //门店变化以后清空经办人
        viewmodel.get("store_name").getFromModel().on('afterValueChange', function (data) {
          viewmodel.get('operator_name').getFromModel().setValue(null);
        });

        //选择经办人之前，如果选择门店，按照门店过滤,否则根据当前用户有权限的门店进行过滤
        viewmodel.get("operator_name").getFromModel().on('beforeBrowse', function (data) {
          var promise = new cb.promise();
          var store_ids = [];
          if (viewmodel.get("store_name").getData().value1 != null && viewmodel.get("store_name").getData().value1 != "") {
            store_ids = viewmodel.get("store_name").getData().value1;
          } else {
            var userStores = cb.rest.AppContext.user.userStores;
            if (userStores != null && userStores != "") {
              for (var i = 0; i < userStores.length; i++) {
                store_ids.push(userStores[i].store);
              }
            }
          }

          if (store_ids != null && store_ids != "" && store_ids.length != 0) {
            var proxy = cb.rest.DynamicProxy.create({
              settle: {
                url: "/bill/ref/getOpsFromStores",
                method: "POST"
              }
            });
            var params = {
              storeIds: store_ids,
            };
            proxy.settle(params, (err, result) => {
              if (err) {
                cb.utils.alert(err.message, 'error');
              }
              if (result === undefined || result.length == 0) {
                cb.utils.alert("没有查询到相关店员！", 'error');
              } else {
                var conditionOp = {
                  "isExtend": true,
                  simpleVOs: []
                };
                conditionOp.simpleVOs.push({
                  field: 'id',
                  op: 'in',
                  value1: result
                });
                viewmodel.get('operator_name').getFromModel().setFilter(conditionOp);
                promise.resolve();
              }
            });
          } else {
            cb.utils.alert("无门店权限！", 'error');
          }
          return promise;
        });

      });
    }

  }
  try {
    module.exports = ST_st_stockinandoutdetail_filterVM_Extend;
  } catch (error) {

  }
  return ST_st_stockinandoutdetail_filterVM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_stockinandoutdetail_filterVM.Extend.js